import { render, staticRenderFns } from "./ModalExcluirMonitoria.vue?vue&type=template&id=73371f04&scoped=true&"
import script from "./ModalExcluirMonitoria.vue?vue&type=script&lang=js&"
export * from "./ModalExcluirMonitoria.vue?vue&type=script&lang=js&"
import style0 from "./ModalExcluirMonitoria.vue?vue&type=style&index=0&id=73371f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73371f04",
  null
  
)

export default component.exports